"use client"

import { motion } from "framer-motion"
import { Link } from "react-router-dom"
import { ArrowLeft, Home } from "lucide-react"
import { Button } from "./button"

const NotFound = () => {
  return (
    <div className="min-h-screen bg-gradient-to-r from-brand-cream to-white flex items-center justify-center p-4">
      <div className="w-full max-w-3xl px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center space-y-6 sm:space-y-8"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          {/* 404 Text */}
          <motion.div
            initial={{ scale: 0.8 }}
            animate={{ scale: 1 }}
            transition={{
              type: "spring",
              stiffness: 200,
              damping: 15,
              delay: 0.2,
            }}
            className="relative"
          >
            <h1 className="text-[100px] sm:text-[150px] md:text-[200px] font-bold text-transparent bg-clip-text bg-gradient-to-r from-brand-gold to-brand-navy">
              404
            </h1>
            <div className="absolute inset-0 bg-gradient-to-r from-brand-gold/20 to-brand-navy/20 blur-3xl -z-10" />
          </motion.div>

          {/* Message */}
          <div className="space-y-3 sm:space-y-4">
            <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-gray-900">Oops! Page Not Found</h2>
            <p className="text-sm sm:text-base text-gray-600 max-w-md mx-auto px-4">
              The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
            </p>
          </div>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 w-full max-w-md mx-auto px-4">
            <Button
              variant="outline"
              className="w-full sm:w-48 group relative overflow-hidden rounded-full px-4 sm:px-6 h-12 sm:h-14 border-2 border-gray-300 hover:border-brand-gold hover:text-brand-gold transition-all duration-300 flex items-center justify-center"
              onClick={() => window.history.back()}
            >
              <ArrowLeft className="w-5 h-5 mr-2 transition-transform group-hover:-translate-x-1" />
              Go Back
            </Button>
            <Link to="/" className="w-full sm:w-48">
              <Button className="w-full group relative overflow-hidden rounded-full px-4 sm:px-6 h-12 sm:h-14 bg-gradient-to-r from-brand-gold to-brand-gold-dark text-white hover:from-brand-gold-dark hover:to-brand-navy transition-all duration-300 flex items-center justify-center">
                <Home className="w-5 h-5 mr-2 transition-transform group-hover:scale-110" />
                Back to Home
              </Button>
            </Link>
          </div>

          {/* Decorative Elements */}
          <motion.div
            className="absolute inset-0 -z-10"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
          >
            <div className="absolute top-1/4 left-1/4 w-32 sm:w-48 md:w-64 h-32 sm:h-48 md:h-64 bg-brand-gold/10 rounded-full blur-3xl" />
            <div className="absolute bottom-1/4 right-1/4 w-32 sm:w-48 md:w-64 h-32 sm:h-48 md:h-64 bg-brand-navy/10 rounded-full blur-3xl" />
          </motion.div>
        </motion.div>
      </div>
    </div>
  )
}

export default NotFound